import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./header";
import { Link } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import { format } from "date-fns";
import "bootstrap/dist/css/bootstrap.min.css";
import "../component/inventory.css";
const Inventory = () => {
const [showStockOut, setShowStockOut] = useState(false);
const [selectedSummary, setSelectedSummary] = useState(null);
const handleClose = () => setShowStockOut(false);
    
const handleShow = () => setShowStockOut(true);
const [pid, setPid] = useState("");

const [did, setDid] = useState("");

const [qty, setQty] = useState("");
const [stockHistory, setStockHistory] = useState([]);
const [description, setDescription] = useState("");

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    //==========================
    // STATES
    //==========================

    const [inventory, setInventory] = useState([]);

    const [products, setProducts] = useState({});

    const [designs, setDesigns] = useState({});

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const [searchTerm, setSearchTerm] = useState("");

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const [selectedImage, setSelectedImage] = useState("");

    const [showImageModal, setShowImageModal] = useState(false);

    // Dashboard

    const [totalProducts, setTotalProducts] = useState(0);

    const [totalStock, setTotalStock] = useState(0);

    const [lowStock, setLowStock] = useState(0);

    const [outStock, setOutStock] = useState(0);

    //==========================
    // FETCH INVENTORY
    //==========================

    useEffect(() => {

        fetchInventory();

    }, []);

    const fetchInventory = async () => {

        try{

            setLoading(true);

            const response = await axios.get(
                `${baseURL}/inventory-summary`
            );

            const data = response.data.inventory || [];

            setInventory(data);

            // Dashboard

            setTotalProducts(data.length);

            let totalQty = 0;

            let low = 0;

            let out = 0;

            data.forEach(item=>{

                totalQty += Number(item.current_qty);

                if(item.current_qty === 0){

                    out++;

                }else if(item.current_qty <= 10){

                    low++;
                }

            });

            setTotalStock(totalQty);

            setLowStock(low);

            setOutStock(out);

            //=========================
            // Product / Design
            //=========================

            const productIds = [
                ...new Set(
                    data.map(item=>item.pid)
                )
            ];

            const designIds = [
                ...new Set(
                    data.map(item=>item.did)
                )
            ];

            await Promise.all([

                fetchProducts(productIds),

                fetchDesigns(designIds)

            ]);

            setLoading(false);

        }catch(err){

            console.log(err);

            setError("Unable to load inventory.");

            setLoading(false);
        }

    };

    const handleStockOut = async (e) => {

        e.preventDefault();
    
        if (!pid || !qty) {
    
            alert("Please select product and quantity.");
    
            return;
        }
    
        try {
    
            const response = await axios.post(
                `${baseURL}/stock-out`,
                {
                    pid,
                    did,
                    qty,
                    description
                }
            );
    
            alert(response.data.message);
    
            fetchInventory();
    
            setPid("");
            setDid("");
            setQty("");
            setDescription("");
    
        } catch (err) {
    
            console.log(err);
    
            alert("Something went wrong.");
    
        }
    
    };


    
    //==========================
    // PRODUCTS
    //==========================
    const fetchStockHistory = async (pid, did) => {

        try {
    
            const response = await axios.get(
                `${baseURL}/stock-summary/${pid}/${did}`
            );
    
            setStockHistory(response.data.history);
    
        } catch (err) {
    
            console.log(err);
    
        }
    
    };
    const fetchProducts = async(ids)=>{

        try{

            const requests = ids.map(id=>

                axios.get(
                    `${baseURL}/product-fetch/${id}`
                )

            );

            const responses = await Promise.all(requests);

            const productMap = {};

            responses.forEach(res=>{

                if(res.data.product){

                    productMap[
                        res.data.product.pid
                    ] = res.data.product;
                }

            });

            setProducts(productMap);

        }catch(err){

            console.log(err);

        }

    };

    //==========================
    // DESIGNS
    //==========================

    const fetchDesigns = async(ids)=>{

        try{

            const requests = ids.map(id=>

                axios.get(
                    `${baseURL}/cart-fetch-design/${id}`
                )

            );

            const responses = await Promise.all(requests);

            const designMap = {};

            responses.forEach(res=>{

                if(
                    res.data.design &&
                    res.data.design.length>0
                ){

                    const design = res.data.design[0];

                    designMap[
                        design.did
                    ] = design;

                }

            });

            setDesigns(designMap);

        }catch(err){

            console.log(err);

        }

    };

    //==========================
    // SEARCH
    //==========================

    const filteredInventory = inventory.filter(item=>{

        return (

            products[item.pid]?.pname
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())

            ||

            designs[item.did]?.dname
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())

            ||

            item.pid
            .toString()
            .includes(searchTerm)

            ||

            item.did
            .toString()
            .includes(searchTerm)

        );

    });

    //==========================
    // PAGINATION
    //==========================

    const indexOfLastItem =
        currentPage * itemsPerPage;

    const indexOfFirstItem =
        indexOfLastItem - itemsPerPage;

    const currentItems =
        filteredInventory.slice(
            indexOfFirstItem,
            indexOfLastItem
        );

    const totalPages =
        Math.ceil(
            filteredInventory.length /
            itemsPerPage
        );

    const changePage=(page)=>{

        if(page<1) return;

        if(page>totalPages) return;

        setCurrentPage(page);

    };

    //==========================
    // IMAGE
    //==========================

    const openImage=(img)=>{

        setSelectedImage(img);

        setShowImageModal(true);

    };

    const closeImage=()=>{

        setSelectedImage("");

        setShowImageModal(false);

    };

    //==========================
    // STATUS
    //==========================

    const getStatus=(qty)=>{

        if(qty===0){

            return "Out Of Stock";

        }

        if(qty<=10){

            return "Low Stock";

        }

        return "In Stock";

    };

    //==========================
    // DATE
    //==========================

    const formatDate=(date)=>{

        if(!date) return "-";

        return format(
            new Date(date),
            "dd MMM yyyy hh:mm a"
        );

    };

    //==========================
    // LOADING
    //==========================

    if(loading){

        return(

            <div className="text-center mt-5">

                <Spinner animation="border"/>

            </div>

        );

    }

    if(error){

        return(

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }
    return (
        <React.Fragment>
    
            <Header />
          
            <div className="container-fluid mt-4">
    
                {/* Breadcrumb */}
    
                <div className="mb-3">
    
                    <ul className="breadcrumb">
    
                        <li className="breadcrumb-item">
                            <Link to="/home">Home</Link>
                        </li>
    
                        <li className="breadcrumb-item active">
                            Inventory
                        </li>
    
                    </ul>
    
                </div>
    
                {/* Dashboard */}
                <div className="row mb-4">

{/* Product */}
<div className="col-lg-3 col-md-6 mb-3">

    <div className="card border-0 shadow h-100">

        <div className="card-body text-center">

            <div className="mb-2">

                <i
                    className="fa fa-box fa-2x text-primary"
                ></i>

            </div>

            <h6 className="text-muted">

                Product

            </h6>
            <select
    className="form-select form-control mb-2"
    value={pid}
    onChange={async (e) => {

        const selectedPid = Number(e.target.value);

        setPid(selectedPid);

        const item = inventory.find(
            x => Number(x.pid) === selectedPid
        );

        if (item) {

            setDid(item.did);

            try {

                const response = await axios.get(
                    `${baseURL}/stock-summary/${item.pid}/${item.did}`
                );

                // setStockHistory(response.data.history);
                // setStockHistory(response.data.history);
    
                const history = response.data.history;

                setStockHistory(history);
                
                const totalIn = history
                    .filter(x => x.transaction_type === "IN")
                    .reduce((sum, x) => sum + Number(x.qty), 0);
                
                const totalOut = history
                    .filter(x => x.transaction_type === "OUT")
                    .reduce((sum, x) => sum + Number(x.qty), 0);
                
                const currentQty =
                    history.length > 0
                        ? Number(history[0].balance_after)
                        : 0;
                
                setSelectedSummary({
                    total_in: totalIn,
                    total_out: totalOut,
                    current_qty: currentQty
                });
            } catch (err) {

                console.log(err);

                setStockHistory([]);

            }

        } else {

            setDid("");

            setStockHistory([]);

        }

    }}
    required
>

    <option value="">Select Product</option>

    {

    inventory.map((item) => (

        <option
            key={item.id}
            value={item.pid}
        >
            {products[item.pid]?.pname} - {designs[item.did]?.dname}
        </option>

    ))
    }
</select>
            <h4 className="fw-bold text-primary">

                {
                    pid
                    ?
                    products[pid]?.pname || "-"
                    :
                    "Select Product"
                }

            </h4>

        </div>

    </div>

</div>

{/* Available */}

<div className="col-lg-3 col-md-6 mb-3">

    <div className="card border-0 shadow h-100">

        <div className="card-body text-center">

            <div className="mb-2">

                <i
                    className="fa fa-cubes fa-2x text-success"
                ></i>

            </div>

            <h6 className="text-muted">

                Available Stock

            </h6>

            <h2 className="fw-bold text-success">

                {
                    selectedSummary
                    ?
                    selectedSummary.current_qty
                    :
                    0
                }

            </h2>

        </div>

    </div>

</div>

{/* Low Stock */}

<div className="col-lg-3 col-md-6 mb-3">

    <div className="card border-0 shadow h-100">

        <div className="card-body text-center">

            <div className="mb-2">

                <i
                    className="fa fa-exclamation-triangle fa-2x text-warning"
                ></i>

            </div>

            <h6 className="text-muted">

                Low Stock

            </h6>

            <h2 className="fw-bold text-warning">

                {

                selectedSummary &&
                selectedSummary.current_qty > 0 &&
                selectedSummary.current_qty <= 10

                ?

                "YES"

                :

                "NO"

                }

            </h2>

        </div>

    </div>

</div>

{/* Stock Out */}

<div className="col-lg-3 col-md-6 mb-3">

    <div className="card border-0 shadow h-100">

        <div className="card-body text-center">

            <div className="mb-2">

                <i
                    className="fa fa-times-circle fa-2x text-danger"
                ></i>

            </div>

            <h6 className="text-muted">

                Stock Out

            </h6>

            <h2 className="fw-bold text-danger">

                {

                selectedSummary &&
                Number(selectedSummary.current_qty) === 0

                ?

                "YES"

                :

                "NO"

                }

            </h2>

        </div>

    </div>

</div>

</div>
              <hr />
                {/* Search */}
    
                <div className="row mb-3" style={{justifyContent:'space-between'}}>
                <div className="col-md-2 mb-3">

<button
    className="btn btn-danger"
    onClick={handleShow}
>
    Stock Out
</button>

</div>
                    <div className="col-md-3">
    
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Product / Design / PID / DID"
                            value={searchTerm}
                            onChange={(e)=>{
    
                                setSearchTerm(e.target.value);
    
                                setCurrentPage(1);
    
                            }}
                        />
    
                    </div>
                    
                </div>
    
                {/* Table */}
              
                <div className="table-responsive shadow rounded p-2" style={{background:'white'}}>
    
                    <table className="table table-bordered table-hover align-middle" style={{background:'white'}}>
    
                        <thead className="table-dark2">
    
                            <tr>
    
                                <th>#</th>
    
                                <th>Image</th>
    
                                <th>Product</th>
    
                                <th>Design</th>
    
                                {/* <th>PID</th>
    
                                <th>DID</th> */}
    
                                <th>Total In</th>
    
                                <th>Total Out</th>
    
                                <th>Available</th>
    
                                <th>Status</th>
    
                                <th>Updated</th>
    
                            </tr>
    
                        </thead>
    
                        <tbody>
    
                            {
    
                                currentItems.length===0 ?
    
                                (
    
                                    <tr>
    
                                        <td
                                            colSpan="11"
                                            className="text-center text-danger"
                                        >
    
                                            No Inventory Found
    
                                        </td>
    
                                    </tr>
    
                                )
    
                                :
    
                                currentItems.map((item,index)=>(
    
                                    <tr key={item.id}>
    
                                        <td>
    
                                            {indexOfFirstItem+index+1}
    
                                        </td>
    
                                        <td>
    
                                            {
    
                                                designs[item.did]?.images ?
    
                                                (
    
                                                    <img
    
                                                        src={`${baseURL}/images/${designs[item.did].images}`}
    
                                                        alt=""
    
                                                        width="60"
    
                                                        height="60"
    
                                                        style={{
    
                                                            cursor:"pointer",
                                                            objectFit:"cover",
                                                            borderRadius:"5px"
    
                                                        }}
    
                                                        onClick={()=>
    
                                                            openImage(
    
                                                                `${baseURL}/images/${designs[item.did].images}`
    
                                                            )
    
                                                        }
    
                                                    />
    
                                                )
    
                                                :
    
                                                "-"
    
                                            }
    
                                        </td>
    
                                        <td>
    
                                            {
    
                                                products[item.pid]?.pname ||
    
                                                "-"
    
                                            }
    
                                        </td>
    
                                        <td>
    
                                            {
    
                                                designs[item.did]?.dname ||
    
                                                "-"
    
                                            }
    
                                        </td>
    
                                        {/* <td>
    
                                            {item.pid}
    
                                        </td>
    
                                        <td>
    
                                            {item.did}
    
                                        </td> */}
    
                                        <td>
    
                                            <span className="badge bg-success">
    
                                                {item.total_in}
    
                                            </span>
    
                                        </td>
    
                                        <td>
    
                                            <span className="badge bg-danger">
    
                                                {item.total_out}
    
                                            </span>
    
                                        </td>
    
                                        <td>
    
                                            <strong>
    
                                                {item.current_qty}
    
                                            </strong>
    
                                        </td>
    
                                        <td>
    
                                            {
    
                                                item.current_qty===0 ?
    
                                                <span className="badge bg-danger">
    
                                                    Out Of Stock
    
                                                </span>
    
                                                :
    
                                                item.current_qty<=10 ?
    
                                                <span className="badge bg-warning text-dark">
    
                                                    Low Stock
    
                                                </span>
    
                                                :
    
                                                <span className="badge bg-success">
    
                                                    In Stock
    
                                                </span>
    
                                            }
    
                                        </td>
    
                                        <td>
    
                                            {
    
                                                formatDate(
    
                                                    item.updated_at
    
                                                )
    
                                            }
    
                                        </td>
    
                                    </tr>
    
                                ))
    
                            }
    
                        </tbody>
    
                    </table>
    
                </div>
    
                {/* Pagination */}
    
                <div className="d-flex justify-content-left gap-2 align-items-center mt-4" style={{gap:'10px'}}>
    
                    <button
    
                        className="btn btn-secondary"
    
                        disabled={currentPage===1}
    
                        onClick={()=>changePage(currentPage-1)}
    
                    >
    
                        Previous
    
                    </button>
    
                    <strong>
    
                        Page {currentPage} of {totalPages}
    
                    </strong>
    
                    <button
    
                        className="btn btn-primary"
    
                        disabled={currentPage===totalPages}
    
                        onClick={()=>changePage(currentPage+1)}
    
                    >
    
                        Next
    
                    </button>
    
                </div>
    
            </div>
            <div className="card m-3 p-2">
                <select
    className="form-select form-control mb-2"
    value={pid}
    onChange={async (e) => {

        const selectedPid = Number(e.target.value);

        setPid(selectedPid);

        const item = inventory.find(
            x => Number(x.pid) === selectedPid
        );

        if (item) {

            setDid(item.did);

            try {

                const response = await axios.get(
                    `${baseURL}/stock-summary/${item.pid}/${item.did}`
                );

                // setStockHistory(response.data.history);
                // setStockHistory(response.data.history);
    
                const history = response.data.history;

                setStockHistory(history);
                
                const totalIn = history
                    .filter(x => x.transaction_type === "IN")
                    .reduce((sum, x) => sum + Number(x.qty), 0);
                
                const totalOut = history
                    .filter(x => x.transaction_type === "OUT")
                    .reduce((sum, x) => sum + Number(x.qty), 0);
                
                const currentQty =
                    history.length > 0
                        ? Number(history[0].balance_after)
                        : 0;
                
                setSelectedSummary({
                    total_in: totalIn,
                    total_out: totalOut,
                    current_qty: currentQty
                });
            } catch (err) {

                console.log(err);

                setStockHistory([]);

            }

        } else {

            setDid("");

            setStockHistory([]);

        }

    }}
    required
>

    <option value="">Select Product</option>

    {

    inventory.map((item) => (

        <option
            key={item.id}
            value={item.pid}
        >
            {products[item.pid]?.pname} - {designs[item.did]?.dname}
        </option>

    ))

    }

</select>
<div className="card-header bg-dark text-white">

    Stock Movement Summary

</div>

<div className="card-body p-0">

    <table className="table table-bordered table-striped mb-0">

        <thead>

            <tr>

                <th>Date</th>

                <th>Type</th>

                <th>Qty</th>

                <th>Balance</th>

                <th>Description</th>

            </tr>

        </thead>

        <tbody>

        {

        stockHistory.length === 0 ?

        (

            <tr>

                <td colSpan="5" className="text-center">

                    No History Found

                </td>

            </tr>

        )

        :

        stockHistory.map((row, index)=>(

            <tr key={index}>

                <td>

                    {formatDate(row.created_at)}

                </td>

                <td>

                    {

                    row.transaction_type === "IN"

                    ?

                    <span className="badge bg-success">

                        IN

                    </span>

                    :

                    <span className="badge bg-danger">

                        OUT

                    </span>

                    }

                </td>

                <td>{row.qty}</td>

                <td>{row.balance_after}</td>

                <td>{row.remarks}</td>

            </tr>

        ))

        }

        </tbody>

    </table>

</div>

</div>
            {/* Image Preview */}
    
            <Modal
                show={showImageModal}
                onHide={closeImage}
                centered
                size="lg"
            >
    
                <Modal.Header closeButton>
    
                    <Modal.Title>
    
                        Product Preview
    
                    </Modal.Title>
    
                </Modal.Header>
    
                <Modal.Body className="text-center">
    
                    {
    
                        selectedImage ?
    
                        <img
    
                            src={selectedImage}
    
                            alt=""
    
                            className="img-fluid"
    
                        />
    
                        :
    
                        "No Image"
    
                    }
    
                </Modal.Body>
    
                <Modal.Footer>
    
                    <Button
                        variant="secondary"
                        onClick={closeImage}
                    >
    
                        Close
    
                    </Button>
    
                </Modal.Footer>
    
            </Modal>
            <Modal
    show={showStockOut}
    onHide={handleClose}
    centered
    size="lg"
>

    <Modal.Header closeButton>

        <Modal.Title>

            Stock Out Product

        </Modal.Title>

    </Modal.Header>

    <form onSubmit={handleStockOut}>

        <Modal.Body>

            <div className="row">

                <div className="col-md-12 mb-3">

                    <label className="form-label">
                        Product
                    </label>

                    <select
                        className="form-select form-control"
                        value={pid}
                        onChange={(e)=>{

                            setPid(e.target.value);

                            const item = inventory.find(
                                x => x.pid == e.target.value
                            );

                            if(item){
                                setDid(item.did);
                            }

                        }}
                        required
                    >

                        <option value="">

                            Select Product

                        </option>

                        {

                        inventory.map((item)=>(

                            <option
                                key={item.id}
                                value={item.pid}
                            >

                                {products[item.pid]?.pname}
                                {" - "}
                                {designs[item.did]?.dname}

                            </option>

                        ))

                        }

                    </select>

                </div>

                <div className="col-md-6 mb-3">

                    <label className="form-label">

                        Quantity

                    </label>

                    <input
                        type="number"
                        className="form-control"
                        value={qty}
                        onChange={(e)=>setQty(e.target.value)}
                        required
                    />

                </div>

                <div className="col-md-12 mb-3">

                    <label className="form-label">

                        Description

                    </label>

                    <textarea
                        className="form-control"
                        rows="4"
                        value={description}
                        onChange={(e)=>setDescription(e.target.value)}
                    />

                </div>

            </div>

        </Modal.Body>

        <Modal.Footer>

            <Button
                variant="secondary"
                onClick={handleClose}
            >
                Cancel
            </Button>

            <Button
                type="submit"
                variant="danger"
            >
                Stock Out
            </Button>

        </Modal.Footer>

    </form>

</Modal>
        </React.Fragment>
    );
}
    export default Inventory;